import { DestroyRef, Directive, DOCUMENT, Inject, OnInit } from '@angular/core';
import { ThemeService } from './theme.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeList, ThemeName } from './model/theme.model';

@Directive({
  selector: 'body[appThemeApplier]',
  host: {
    '[attr.data-theme]': 'themeAttribute',
  },
})
export class ThemeApplierDirective implements OnInit {
  themeAttribute: ThemeName = ThemeList.DEFAULT;

  constructor(
    private themeService: ThemeService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.themeService.currentTheme$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        this.themeAttribute = theme;
      });
  }
}
